import axios from 'axios'
import { ElMessage } from 'element-plus'
// import { diffTokenTime } from '@/utils/auth'
// diffTokenTime
import store from '@/store'
import {
  ensureGsfmsTokenValid,
  shouldRunGsfmsTokenCheck
} from '@/utils/tokenCheck'
console.log('查看当前域名----》', process.env.VUE_APP_BASE_API)
// 根据环境动态设置 baseURL
// const baseURL =
//   process.env.NODE_ENV === 'development'
//     ? 'https://www.ipolarx.com/api' // 开发环境
//     : process.env.VUE_APP_BASE_API || 'https://www.ipolarx.com/api' // 生产环境

// console.log('当前环境:', process.env.NODE_ENV)
// console.log('当前 API 地址:', baseURL)

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || 'https://www.ipolarx.com/api', // 添加默认值,
  timeout: 180000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

// 请求拦截器
service.interceptors.request.use(
  async (config) => {
    // 固定时间的跳转登录
    // if (localStorage.getItem('token')) {
    //   if (diffTokenTime()) {
    //     store.dispatch('app/logout')
    //     return Promise.reject(new Error('token 失效了'))
    //   }
    // }
    if (shouldRunGsfmsTokenCheck(config)) {
      await ensureGsfmsTokenValid()
    }
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    return config
  },
  (error) => {
    return Promise.reject(new Error(error))
  }
)

// 相应拦截器
service.interceptors.response.use(
  (response) => {
    const resData = response.data
    // console.log('相应拦截器resData---', resData)

    if (response.config._rawResponse) {
      return resData
    }

    if (
      response.status === 200 ||
      response.status === 201 ||
      resData.status === 'success'
    ) {
      // 查看当前域名
      if (resData.error_code === 101006) {
        // console.log('token过期')
        store.dispatch('app/logout')
      }
      if (
        response.headers['content-disposition'] &&
        response.headers['content-disposition'].includes('xls')
      ) {
        // 文件下载
        return response
      }
      return resData
    } else {
      ElMessage.error(resData.description || '响应异常')
      return Promise.reject(new Error(resData.status))
    }
  },
  (error) => {
    console.log('拦截器报错---》', error.response)
    if (error.response.data.error_code === 101006) {
      // console.log('token过期')
      store.dispatch('app/logout')
      return
    }
    if (error.response?.data?.description) {
      ElMessage.error(error.response.data.description || '响应异常')
    }
    error.response && ElMessage.error(error.response.data)
    return Promise.reject(new Error(error.response.data))
  }
)
export default service
